import i18n from "../i18n/i18n";

/** BCP-47 locale to use with Intl/Date formatting APIs, based on the active UI language. */
export function getDateLocale() {
    return i18n.language && i18n.language.startsWith("en") ? "en-US" : "es-CO";
}
